module.exports = __webpack_public_path__ + "img/defaultdp.ae42f254.svg";